module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.cebd892d.ttf";